import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import classNames from "classnames";
import { getUser } from "@jti/rest-api";
import { useLoyalty } from "@jti/ui";
import { MembershipLevelDisplay } from "../membership-level-display/MembershipLevelDisplay";
import PointsDisplay from "../points-display/PointsDisplay";
import styles from "./style.module.scss";
export const LoyaltyMembershipInfo = ({ title, membershipLabel = "", pointsLabel = "", hideTierBadge, }) => {
    const isLoyaltyActive = useLoyalty();
    const user = getUser();
    useEffect(() => {
        const loyaltyElement = document.getElementById("isLoyalty");
        if (isLoyaltyActive) {
            loyaltyElement?.classList.remove("navigation__item-loyalty");
        }
        else {
            loyaltyElement?.classList.add("navigation__item-loyalty");
        }
    }, [isLoyaltyActive]);
    if (isLoyaltyActive && !user?.uuid && !user?.ciam_token) {
        return null;
    }
    return (_jsxs("div", { className: styles.infoLoyaltyContent, children: [title && _jsx("h3", { className: styles.title, children: title }), _jsxs("div", { className: classNames("loyaltyMembershipInfo", styles.loyaltyMembershipInfo), children: [!hideTierBadge && (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.item, children: [membershipLabel && _jsx("span", { className: styles.label, children: membershipLabel }), _jsx(MembershipLevelDisplay, {})] }), _jsx("span", { className: styles.divider })] })), _jsxs("div", { className: styles.item, children: [pointsLabel && _jsx("span", { className: styles.label, children: pointsLabel }), _jsx(PointsDisplay, { isStyledNumber: false })] })] })] }));
};
//# sourceMappingURL=LoyaltyMembershipInfo.js.map